import alt from "../../alt";
import actions from "../../actions/RegistrationActions";
import source from "../../sources/forms/RegistrationSource";

class RegistrationStore {
  constructor() {
    this.authorities = []; // list of all auyhorities from REST API call
    this.authority = ""; // Authority selected by the user
    this.email = "";
    this.password = "";
    this.first_name = "";
    this.last_name = "";
    this.terms = false;
    this.loading = false;
    this.success = false;
    this.errorMessage = null;
    this.bindListeners({
      updateAuthority: actions.UPDATE_AUTHORITY,
      updateEmail: actions.UPDATE_EMAIL,
      updatePassword: actions.UPDATE_PASSWORD,
      updateFirstname: actions.UPDATE_FIRSTNAME,
      updateLastname: actions.UPDATE_LASTNAME,
      updateTerms: actions.UPDATE_TERMS,
      updateLoading: actions.LOADING,
      submitForm: actions.SUBMIT_FORM,
      submitSuccess: actions.SUBMIT_SUCCESS,
      submitError: actions.SUBMIT_ERROR,
      updateAuthorities: actions.UPDATE_AUTHORITIES,
      fetchAuthorities: actions.FETCH_AUTHORITIES,
      errorAuthorities: actions.ERROR_AUTHORITIES,
    });

    this.registerAsync(source);
  }

  updateAuthority(authority) {
    this.authority = authority;
  }

  fetchAuthorities() {
    this.authorities = [];

    if (!this.getInstance().isLoading()) {
      this.getInstance().fetch();
    }
  }

  updateAuthorities(authorities) {
    if (authorities.hasOwnProperty("data")) {
      this.authorities = authorities.data.result;
    } else {
      this.authorities = authorities;
    }
    if (this.authorities.length == 1) {
      this.authority = this.authorities[0]["id"];
    }
  }
  errorAuthorities(errorMessage) {
    console.log(errorMessage);
  }

  updateEmail(email) {
    this.email = email;
  }
  updatePassword(password) {
    this.password = password;
  }
  updateFirstname(first_name) {
    this.first_name = first_name;
  }

  updateLastname(last_name) {
    this.last_name = last_name;
  }

  updateTerms(terms) {
    this.terms = terms;
  }

  updateLoading(loading) {
    this.loading = loading;
  }

  submitForm() {
    if (!this.getInstance().isLoading()) {
      this.getInstance().submit();
    }
  }

  submitSuccess(response) {
    this.success = true;
  }

  submitError(response) {
    this.errorMessage = response.data.error;
  }
}

export default alt.createStore(RegistrationStore, "RegistrationStore");
